import axios from "axios";
import SERVER from '@/API/url';

const UserAccountStore = {
    namespaced: true,
    state: {
        
    },
    getters: {

    },
    mutations: {

    },
    actions: {

        // 로그인
        login: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/login', params,
                { headers: SERVER.HEADERS }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 로그아웃
        logout: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/logout?user_id='+params.user_id, params,
                { headers: SERVER.HEADERS }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 자동로그인 - refreshtoken 이용해서 재발급
        refreshToken: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/refresh_token/', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 사용자 정보 조회
        getUserData: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.get(SERVER.URL + '/api/UserAccount/GetUserData?user_id='+params.user_id,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 회원가입
        join: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/join/', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 회원정보 수정
        edit: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.put(SERVER.URL + '/api/UserAccount/edit/' + params.user_id, params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 비밀번호 변경
        updatepassword: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/updatepassword', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 비밀번호 확인
        checkpassword: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/checkpassword', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 아이디 찾기
        findloginid: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.get(SERVER.URL + '/api/UserAccount/findloginid?phone='+params.phone+'&email='+params.email,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 비밀번호 찾기 - 이메일 발송
        findpassword: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/sendPasswordResetEmail/'+params.login_id, {},
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 비밀번호 변경 (비밀번호 찾기)
        resetpassword: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/resetpassword', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },
    }
}

export default UserAccountStore